import { render, staticRenderFns } from "./ContentViewGlobalDrawer.vue?vue&type=template&id=2d4cf968&scoped=true&"
import script from "./ContentViewGlobalDrawer.vue?vue&type=script&lang=js&"
export * from "./ContentViewGlobalDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewGlobalDrawer.vue?vue&type=style&index=0&id=2d4cf968&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4cf968",
  null
  
)

export default component.exports